import { BATCH_FILE_FORMAT, WizCommand, WizIcon, WizPopUp, WizRoot } from '@wizeoo/akm-component-lib';
import { APP_ORIGIN, WIZ_COMMAND_HTTP_METHOD} from '@wizeoo/akm-core-lib'
import { ExternalAPI } from '../../model/external-api';
import { BatchWrapper, UploadWrapper } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { ViewData } from '../../model/view.data';
import { BATCH_KIND } from '../../manager/export/batch-engine';
import { EnvironnementManager } from '../../model/environnement.manager';

/**
 * Appels Batch
 */
export class BatchCmd extends WizCommand<BatchWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }

  
  /**
   * Construit le wrapper des batchs avec les informations de base
   * @returns Wrapper
   */
  public BatchWrapper(): BatchWrapper {
    const wrapper: BatchWrapper = new BatchWrapper();
    wrapper.domain = this.model.origin === APP_ORIGIN.DOM ? this.model.currentDomainCode : this.model.domainCode;
    wrapper.bu = this.model.origin === APP_ORIGIN.DOM ? this.model.currentBUCode : this.model.businessUnitCode;
    wrapper.login = this.model.connectedUser.mail;
    wrapper.locale = this.model.currentLocaleCode;
    wrapper.uuid = WizRoot.getInstance().uuid;
    return wrapper;
  }

  /**
   * Construit le wrapper pour l'upload
   * TODO merger avec BatchWrapper
   */
  public UpWrapper(): UploadWrapper {
    const wrapper: UploadWrapper = new UploadWrapper();
    wrapper.domain = this.model.origin === APP_ORIGIN.DOM ? this.model.currentDomainCode : this.model.domainCode;
    wrapper.businessUnitCode = this.model.origin === APP_ORIGIN.DOM ? this.model.currentBUCode : this.model.businessUnitCode;
    wrapper.login = this.model.connectedUser.mail;
    wrapper.fileFormat = 'csv'; // TODO gérer dynamiquement
    wrapper.cleanOnExit = 0;
    wrapper.uuid = WizRoot.getInstance().uuid;
    return wrapper;
  }



  /** 
   * Déclenche l'export
   * 
   * @param batchKind 
   * @param fileFormat 
   * @param criteriaKey 
   * @returns 
   */
  public export(batchKind: string, fileFormat: string = null, criteriaKey: string = null): WizCommand<any> {
    const wrapper: BatchWrapper = this.BatchWrapper();
    wrapper.method = WIZ_COMMAND_HTTP_METHOD.POST;
    wrapper.requiredClass = batchKind;
    wrapper.format = fileFormat ? fileFormat : BATCH_FILE_FORMAT.CSV;
    wrapper.criteriaKey = criteriaKey;

    // TODO * sur language et country
    if (BATCH_KIND.LANGUAGE === batchKind || BATCH_KIND.COUNTRY === batchKind) {
      wrapper.domain = ViewData.wildcardDomain;
      wrapper.bu = ViewData.wildcardDomain;
    }

    this.configureRemote(EnvironnementManager.envConfig.batchUrl + '/' + ExternalAPI.BATCH_EXPORT, wrapper, this.getCallBackExport);
    return this;
  }

  /**
   * Déclenche l'import
   * @param batchKind : type d'import souhaité
   * @param fileName : Le nom du fichier
   * @param bytes : binaire du fichier
   * @param cancelReplaceDatas : Annuler/remplacer les données (cas de l'import en masse d'une bu et ses sous-données)
   * @param skipInconsistentData : Ignorer les données incohérentes
   * TODO gestion extension
   */
  public import(batchKind: string, fileName: string, bytes: string, massImportSelectBuCode: string, cancelReplaceDatas: boolean, skipInconsistentData: boolean): WizCommand<any> {
    const wrapper: UploadWrapper = this.UpWrapper();
    wrapper.batchKind = batchKind;
    wrapper.file = bytes; // `${fileName}|${bytes}`;
    const parts: string[] = fileName.split('.');
    wrapper.fileFormat = parts[parts.length - 1]; // LMA... Si y'a un point dans le nom de fichier ??
    wrapper.fileName = fileName;
    wrapper.uuid = WizRoot.getInstance().uuid;

    // Si on importe une BU avec ses sous-données 
    if (BATCH_KIND.META_BU === batchKind) 
    {
      // on utilise potentiellement une autre BU que celle fournie dans le fichier
      if (!!massImportSelectBuCode)
      {
        wrapper.businessUnitCode = massImportSelectBuCode; 
        wrapper.batchKind = BATCH_KIND.META_BU_SELECT_BU;
      }
      wrapper.cancelReplaceDatas = cancelReplaceDatas;
      wrapper.skipInconsistentData = skipInconsistentData;
    }

    this.configureRemote(EnvironnementManager.envConfig.batchUrl + '/' + ExternalAPI.BATCH_UPLOAD_FILE, wrapper, this.getCallBackImport)
    return this;
  }

  /**
   * Callback batch export
   * @param data  WizCommand contenant le résultat
   */
  public getCallBackExport(data: WizCommand<any>) {
    this.result = data.result;

    if (this.result?.status !== 'FAILED') {
      WizPopUp.toast('$.batch.processing.export.$', WizIcon.TOAST_SUCCESS).show();
    } else {
      let mess: string = this.model.localeEngine.translateKey('$.batch.failed.export.$');
      mess = mess + ': ' + data.error.message;
      WizPopUp.toast(mess, WizIcon.TOAST_ERROR).show();
    }
  }

  /**
   * Callback batch import
   * @param data  WizCommand contenant le résultat
   */
  public getCallBackImport(data: WizCommand<any>) {
    this.result = data.result;

    if (this.result?.status !== 'FAILED') {
      WizPopUp.toast('$.batch.processing.import.$', WizIcon.TOAST_SUCCESS).show();
    } else {
      WizPopUp.toast('$.batch.failed.import.$', WizIcon.TOAST_ERROR).show();
    }
  }

  /**
   * retour de service
   * gestion de retour selon la méthode d'appelle
   */
  public wizResult(): void {
    super.wizResult();
  }

  /**
   * Surcharge du wizFault pour notification des erreurs "technique".
   * Les erreurs métier sont dans wizResult
   */
  public wizFault() {
    super.wizFault();
  }
}
